import axios from "axios";
import {WIT_API_CONFIG} from "../config/witApiConfig";

const witIntentApiService = {
  async loadIntents(authToken) {
    const response = await axios.get(WIT_API_CONFIG.intentsUrl, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    return Array.isArray(response.data?.intents) ? response.data.intents : [];
  },

  async loadEntities(authToken) {
    const response = await axios.get(WIT_API_CONFIG.entitiesUrl, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    return Array.isArray(response.data?.entities) ? response.data.entities : [];
  },
};

export default witIntentApiService;
